import { render, staticRenderFns } from "./EnterInsuranceDetailsPage.vue?vue&type=template&id=22496bb0"
import script from "./EnterInsuranceDetailsPage.vue?vue&type=script&lang=js"
export * from "./EnterInsuranceDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports